'use strict';

var _ = require('lodash');
var PooledSeasonalityLabelChartDataService = function PooledSeasonalityLabelChartDataService(seasonalityConstants, pooledSeasonalityReviewConstants, pooledReviewCalendarService, pooledSeasonalityChartDataTransformationService, pooledSeasonalityChartsHelper) {
  function getIndexProfileData(searchParams) {
    var market = searchParams.market.split('-');
    if (searchParams.seasonalityType !== seasonalityConstants.SEASONALITY_TYPE.POOLED) {
      return;
    }
    var calendarName;
    var filters = {
      origin: market[0],
      destination: market[1],
      cabin: searchParams.cabin,
      significantPOS: searchParams.spos,
      daysToDeparture: searchParams.maxRtp
    };
    var localFilter = [{
      attribute: 'attributes.dowGroup',
      filter: [searchParams.dowGroup]
    }];
    var profileType = pooledSeasonalityChartsHelper.getProfileName(searchParams.flowType, pooledSeasonalityReviewConstants.PROFILE_TYPE.INDEX);
    if (pooledSeasonalityChartsHelper.isProfileInactiveOrPublishing(searchParams)) {
      calendarName = searchParams.calendarName;
    } else {
      filters.scenarioName = pooledSeasonalityChartsHelper.getScenarioName(searchParams);
    }
    return pooledReviewCalendarService.fetchHepProfiles(profileType, filters, localFilter, calendarName);
  }
  function getWoyIndices(indexProfile) {
    return pooledSeasonalityChartDataTransformationService.getWoyIndices(indexProfile);
  }
  function getCabins(market) {
    return _.keys(pooledReviewCalendarService.getCabinClassGroups(market));
  }
  return {
    getIndexProfileData: getIndexProfileData,
    getWoyIndices: getWoyIndices,
    getCabins: getCabins
  };
};
PooledSeasonalityLabelChartDataService.$inject = ['SeasonalityConstants', 'PooledSeasonalityReviewConstants', 'PooledReviewCalendarService', 'PooledSeasonalityChartDataTransformationService', 'PooledSeasonalityChartsHelper'];
module.exports = PooledSeasonalityLabelChartDataService;